module.exports = __webpack_public_path__ + "static/img/icon-regonline.0656d52.png";


//////////////////
// WEBPACK FOOTER
// ./static/theme/tcms/img/icon-regonline.png
// module id = YRcj
// module chunks = 15